module.exports = __webpack_public_path__ + "img/home.64b083c6.svg";